import { render, staticRenderFns } from "./backgroundCheckRecord.vue?vue&type=template&id=3e4d7cc6&scoped=true&"
import script from "./backgroundCheckRecord.vue?vue&type=script&lang=js&"
export * from "./backgroundCheckRecord.vue?vue&type=script&lang=js&"
import style0 from "./backgroundCheckRecord.vue?vue&type=style&index=0&id=3e4d7cc6&prod&scoped=true&lang=css&"
import style1 from "./backgroundCheckRecord.vue?vue&type=style&index=1&id=3e4d7cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d7cc6",
  null
  
)

export default component.exports